import { useEffect, useState } from 'react';
import { AppState } from '../../../../corelogic/state/app.state';
import { clearError } from '../../../../corelogic/state/error/error.action';
import { ErrorType } from '../../../../corelogic/state/error/error.action.type';
import { store } from '../../../../corelogic/state/store';

export const useError = (
  errorSelector: (state: AppState) => string | null,
  errorType: ErrorType,
) => {
  const [error, setError] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const error$ = store.select(errorSelector);

  useEffect(() => {
    const subscription = error$.subscribe((newError) => {
      if (newError !== error) {
        // Only update if error changed
        setError(newError);
        setIsVisible(!!newError);
      }
    });
    return () => subscription.unsubscribe();
  }, [error$, error]); // Added error to dependencies

  const hideError = () => {
    setIsVisible(false);
    setError(null);
    store.dispatch(clearError(errorType));
  };

  return { error, isVisible, hideError };
};
